'use strict'

const { formatDuration } = require('./duration-column')

function csvField (value) {

  let text = value == null ? '' : String(value)

  if (/^[=+@]/.test(text)) text = `'${text}`

  if (/[",\r\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`

  return text
}

function csvLine (values) {

  return `${(values || []).map(csvField).join(',')}\r\n`
}

function csvFilename (title) {

  const cleaned = String(title || 'spreadsheet').replace(/[^\w.-]+/g, '_').replace(/^_+|_+$/g, '')

  return `${cleaned || 'spreadsheet'}.csv`
}

function stripRichText (value) {

  if (value == null || value === '' || typeof value !== 'string') return ''

  return value
    .replace(/<img[^>]*alt="([^"]*)"[^>]*>/gi, ' [$1] ')
    .replace(/<img[^>]*>/gi, ' [image] ')
    .replace(/<a[^>]*>(.*?)<\/a>/gi, ' $1 ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
}

function multiselectText (value) {

  if (value == null || value === '') return ''
  if (Array.isArray(value)) return value.map(item => String(item)).join(', ')
  if (typeof value !== 'string') return String(value)

  const trimmed = value.trim()

  if (!trimmed.startsWith('[')) return value

  try {

    const parsed = JSON.parse(trimmed)

    if (Array.isArray(parsed) && parsed.every(item => typeof item === 'string' || typeof item === 'number')) {

      return parsed.map(item => String(item)).join(', ')
    }
  } catch (error) {}

  return value
}

function relationshipText (records) {

  if (!Array.isArray(records) || records.length === 0) return ''

  return records.map((record) => {

    if (record && typeof record === 'object') {

      const displayKey = Object.keys(record).find((key) => {

        return key !== 'id' && key !== 'createdAt' && key !== 'updatedAt' && !key.endsWith('_from') && !key.endsWith('_to') && record[key] != null && typeof record[key] !== 'object'
      })

      if (displayKey) return String(record[displayKey])
      if (record.id != null) return `#${record.id}`

      return ''
    }

    return record == null ? '' : `#${record}`
  }).filter(Boolean).join(', ')
}

function cellText (row, field) {

  if (!row || !field || field.type === 'password') return ''

  if (field.type === 'relationship') return relationshipText(row[`${field.key}_from`])
  if (field.type === 'multiselect') return multiselectText(row[field.key])
  if (field.type === 'richText') return stripRichText(row[field.key])
  if (field.type === 'duration') return formatDuration(row[field.key], field.durationUnit)
  if (field.type === 'signature') return row[`${field.key}_filename`] ? String(row[`${field.key}_filename`]) : ''

  const value = row[field.key]

  if (value == null || value === '') return ''

  if (typeof value === 'object') return row[`${field.key}_filename`] ? String(row[`${field.key}_filename`]) : ''

  return String(value)
}

function spreadsheetCsv (fields, rows) {

  const columns = (fields || []).filter(field => field && field.type !== 'password')
  let csv = `\uFEFF${csvLine(columns.map(field => field.label || field.key || ''))}`

  for (const row of rows || []) {

    csv += csvLine(columns.map(field => cellText(row, field)))
  }

  return csv
}

module.exports = {
  csvFilename,
  spreadsheetCsv,
  cellText,
  csvLine
}
